import { Box, Button, Card, Typography } from "@material-ui/core";
import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import "../index.css";
import { useDataProvider } from "ra-core";
import { useNotify, useRefresh, useInput, ImageField } from "react-admin";
import JoditEditor from "jodit-react";
import _debounce from "lodash/debounce";
import TitleText from "../../common/title-text";
import SubtitleText from "../../common/subtitle-text";
import "jodit";
import "jodit/build/jodit.min.css";
import HTMLReactParser from "html-react-parser";

export const defaultSchema = `<script type="application/ld+json">
{
  "@context": "https://schema.org",
  "@type": "BlogPosting",
  "mainEntityOfPage": {
    "@type": "WebPage",
    "@id": "https://rafflehouse.com/blog/sample-post"
  },
  "headline": "Sample Blog Post",
  "description": "This is a short description for the blog post.",
  "image": "https://rafflehouse.com/sample-image.jpg",
  "author": {
    "@type": "Organization",
    "name": "Raffle House",
    "url": "https://rafflehouse.com"
  },
  "publisher": {
    "@type": "Organization",
    "name": "Raffle House",
    "logo": {
      "@type": "ImageObject",
      "url": "https://rafflehouse.com/extensions/images/redesign-v2/rafflehouse-logo.svg"
    }
  },
  "datePublished": "2025-10-01"
}
</script>

<script type="application/ld+json">
{
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": [
    {
      "@type": "Question",
      "name": "What is Raffle House?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Raffle House is a UK-based company that lets people win properties through raffles."
      }
    },
    {
      "@type": "Question",
      "name": "",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": ""
      }
    }
  ]
}
</script>`;

const BlogSchemaEditor = (props) => {
  //   const defaultSchema = {
  //   "@context": "https://schema.org",
  //   "@type": "BlogPosting",
  //   "mainEntityOfPage": {
  //     "@type": "WebPage",
  //     "@id": ""
  //   },
  //   "headline": "",
  //   "description": "",
  //   "image": "",
  //   "author": {
  //     "@type": "Organization",
  //     "name": "Raffle House",
  //     "url": "https://rafflehouse.com"
  //   },
  //   "publisher": {
  //     "@type": "Organization",
  //     "name": "Raffle House",
  //     "logo": {
  //       "@type": "ImageObject",
  //       "url": "https://rafflehouse.com/extensions/images/redesign-v2/rafflehouse-logo.svg"
  //     }
  //   },
  //   "datePublished": ""
  // };

  const {
    input: { name, onChange, value },
    meta: { touched, error },
  } = useInput(props);

  console.log("record", props.record);

  // const [text, setText] = useState("");

  // useEffect(() => {
  //   if (!value) {
  //     const formatted = JSON.stringify(defaultSchema, null, 2);
  //     setText(formatted);
  //     onChange(formatted);
  //   } else {
  //     try {
  //       const parsed = JSON.parse(value);
  //       setText(JSON.stringify(parsed, null, 2));
  //     } catch (err) {
  //       setText(value);
  //     }
  //   }
  // }, [value]);

  const handleChange = (e: { target: { value: string } }) => {
    const newValue = e.target.value;
    // setText(newValue);

    // try {
    //   // const parsed = JSON.parse(newValue);
    onChange(newValue);
    // } catch {
    //   console.warn("Invalid JSON, not saved");
    // }
  };

  const decodeEscapedString = (str: string) => {
    if (typeof str !== "string") return str;
    return str
      .replace(/\\"/g, '"')
      .replace(/\\n/g, "\n")
      .replace(/\\t/g, "\t")
      .replace(/\\\\/g, "\\");
  };

  const decodedValue = decodeEscapedString(props.isShow ? (value || "no data...") : (value || defaultSchema));

  useEffect(() => {
    onChange(decodedValue);
  }, [value]);

  const generateScheme = () => {
    const details = props.record;
    const newScheme = `<script type="application/ld+json">
{
  "@context": "https://schema.org",
  "@type": "BlogPosting",
  "mainEntityOfPage": {
    "@type": "WebPage",
    "@id": "https://rafflehouse.com/blog/${
      details.slug ? details.slug : '"sample-post"'
    }"
  },
  "headline": ${
    details.title ? '"' + details.title + '"' : '"Sample Blog Post"'
  },
  "description": ${
    details.shortDescription ? '"' + details.shortDescription + '"' : '"This is a short description for the blog post."'
  },
  "image": ${
    details.filesPreviewImage?.src ? '"' + details.filesPreviewImage.src + '"' : '"https://rafflehouse.com/sample-image.jpg"'
  },
  "author": {
    "@type": "Organization",
    "name": "Raffle House",
    "url": "https://rafflehouse.com"
  },
  "publisher": {
    "@type": "Organization",
    "name": "Raffle House",
    "logo": {
      "@type": "ImageObject",
      "url": "https://rafflehouse.com/extensions/images/redesign-v2/rafflehouse-logo.svg"
    }
  },
  "datePublished": ${
    details.publishAt ? '"' + details.publishAt + '"' : '"2025-10-01"'
  }
}
</script>

<script type="application/ld+json">
{
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": [
    {
      "@type": "Question",
      "name": "What is Raffle House?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Raffle House is a UK-based company that lets people win properties through raffles."
      }
    },
    {
      "@type": "Question",
      "name": "",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": ""
      }
    }
  ]
}
</script>`;
    onChange(newScheme);
  };

  return (
    <React.Fragment>
      {!props.isShow && <Button onClick={generateScheme} className="post__generate-btn">
        Generate from blog details
      </Button>}
      <Box display={"flex"} flexDirection={"column"} height={"600px"}>
        <Typography gutterBottom className="base-color">
          Blog Schema (JSON-LD)
        </Typography>
        <textarea
          className="post__textarea"
          // value={text}
          // value={value || defaultSchema}
          value={decodedValue}
          onChange={handleChange}
          disabled={props.isShow}
        />
        {touched && error && (
          <Typography color="error" variant="caption">
            {error}
          </Typography>
        )}
      </Box>
    </React.Fragment>
  );
};
export default BlogSchemaEditor;
